import { IconChevronLeft } from '@carnica/graphics';
import { Button } from '@carnica/ui-kit';
import { compose } from '@reduxjs/toolkit';
import React from 'react';
import { connect } from 'react-redux';
import { HeaderThemeView } from '@carnica/smart-kit';

import { selectHeaderTheme } from 'store/common/specialProjectHeader/selectors';

export const onClick = () => () => {
  window.location.href = '/shop/';
};

export default compose<React.FC>(
  connect(
    (state) => ({
      size: 'm',
      onlyIcon: true,
      view: HeaderThemeView[selectHeaderTheme(state)],
      iconLeft: IconChevronLeft,
    }),
    {
      onClick,
    },
  ),
)(Button);
